import httpAuth from "../../services/httpAuth";
import getErrorMessage from "../../helpers/getErrorMessage.helper";
import {
  getExposureError,
  getExposureFancySuccess,
  getExposureSuccess,
  getOrdersError,
  getOrdersSuccess,
} from "./eventPage.slice";

export const requestSportStart =
  (eventId, isRacing, eventTypeId, marketId) => async (dispatch, getState) => {
    try {
      // twitter-config - in another reqest if news tab opened
      const userId = getState().auth;
      let data = {
        match_id: eventId,
      };
      if (isRacing) {
        data = {
          market_id: marketId,
        };
      }

      if (userId) {
        //exposure for regular markets
        httpAuth.post(`bet/getTeamPosition`, data).then((res) => {
          if (res.data.status) {
            dispatch(getExposureSuccess(res.data.data));
          }
        });

        if (isRacing) return;

        //exposure for Fancy

        if (eventTypeId == "4") {
          httpAuth.post(`bet/getFancyLiability`, data).then((res) => {
            if (res.data.status) {
              dispatch(getExposureFancySuccess(res.data.data));
            }
          });
        }
      }
      return;
    } catch (e) {
      dispatch(getExposureError());
    }
  };
